module.exports = __webpack_public_path__ + "media/index/money-f1958891.svg";